import React from 'react';
import { Route, Link, withRouter } from "react-router-dom";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import MaterialTable from 'material-table'
import { List } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';


export class GlobalResults extends React.Component {
    constructor(props){
      super(props)
      this.state = {
        userlist : []
      }
    }

    componentDidMount (){
        
        let s = this.props.socket
        s.emit('get full user review',{}, data => {
            this.setState({userlist:data})
            console.log(data)
        })
      }

      columns =  [
        {title : 'Mitarbeiter', field : 'user',
        render : rowData => {return (<span>{rowData.user} </span>) } },
        {title : 'Qualifikation', field : 'qualification',
        render : rowData => {return (<span>{rowData.qualification} </span>) } },
        {title : 'Fortbildungen', field : 'fb.length',
        cellStyle: (e, rowData) => {
          return {backgroundColor: rowData.fb.length == rowData.fbmax ? '#00800045' : '#ff000021'}
          },
        render : rowData => {return (
        <span>{rowData.fb.length} (von {rowData.fbmax}) </span>
        ) } },
        {title : 'Unterweisungen', field : 'uw.length',
        cellStyle: (e, rowData) => {  
          return {backgroundColor: rowData.uw.length == rowData.uwmax ? '#00800045' : '#ff000021'}
          },
        render : rowData => {return (
          <span>{rowData.uw.length} (von {rowData.uwmax}) </span>
        ) } },
    
      ]
    
      options= {
        pageSize : 15,
        columnsButton : true

      }

      detailPanel =  [
        {
          tooltip: 'absolviert',
          render: rowData => {
            return (
              <List dense>
                {rowData.fb && rowData.fb.map((d,i) => 
                <Paper key={'fb'+i}>
                  <ListItem>
                    <ListItemText primary={d}/>
                  </ListItem>
                </Paper>
                )}
                {rowData.uw && rowData.uw.map((d,i) => 
                <Paper key={'uw'+i}>
                  <ListItem>
                    <ListItemText primary={d}/>
                  </ListItem>
                </Paper>
                )}
              </List>
            )
          },
        },
        ]


    render () {
      	const {userlist} = this.state
        return (<>

        {userlist &&  <MaterialTable columns={this.columns} options={this.options} detailPanel={this.detailPanel} data={userlist} title="Testergebnisse"/>}
        
        </>)
    }
    

}